import { DocumentHistoryGrid, IDocumentHistoryGridConfig } from "./document-history-grid.js";
import { DocumentHistoryFilters, IDocumentHistoryFilterValues, IDocumentHistoryFilterLabels } from "./document-history-filters.js";
import { IStandardApiError } from "../../../components-shared/api/base/i-standard-api-error.js";

export interface IDocumentHistoryConfig {
    itemsPerPage: number;
    rootFolderId: number;
    tagCategoriesRootId: number;
    screenshotsRelationsIDs: number[];
    screenshotImageWidth: number;
    screenshotImageModification: string;
    renderPageId: number;
    errorReporter: (error: IStandardApiError) => void;
}

export class DocumentHistory extends HTMLElement {
    constructor(private config: IDocumentHistoryConfig, private labelsSource: any) {
        super();
    }

    /* #region Event handlers */
    filterValuesChanged(values: IDocumentHistoryFilterValues) {
        const gridConfig = this.createGridConfig(values);
        this.grid.setConfig(gridConfig);
    }
    /* #endregion */

    /* #region Private */
    private isInitialized: boolean = false;
    private filters: DocumentHistoryFilters;
    private grid: DocumentHistoryGrid;

    private initialize() {
        const header = document.createElement("div");
        header.classList.add("header");

        const headerTitle = document.createElement("h1");
        headerTitle.innerText = this.labelsSource.documentHistory;

        header.appendChild(headerTitle);
        this.appendChild(header);

        this.filters = new DocumentHistoryFilters(this.config, this.labelsSource as IDocumentHistoryFilterLabels);
        this.filters.onFilterChanged = this.filterValuesChanged.bind(this);

        this.appendChild(this.filters);

        const gridConfig = this.createGridConfig(this.filters.values);

        this.grid = new DocumentHistoryGrid(gridConfig, this.labelsSource);
        this.appendChild(this.grid);
    }

    private createGridConfig(filterValues: IDocumentHistoryFilterValues): IDocumentHistoryGridConfig {
        return {
            itemsPerPage: this.config.itemsPerPage,
            searchTerm: filterValues.searchTerm,
            //fromDate: values.fromDate,
            rootFolderId: this.config.rootFolderId,
            tagCategoriesRootId: this.config.tagCategoriesRootId,
            filterGroups: filterValues.selectedGroups.map(g => g.key),
            filterTags: filterValues.selectedTags.map(t => t.key),
            screenshotsRelationsIDs: this.config.screenshotsRelationsIDs,
            screenshotImageWidth: this.config.screenshotImageWidth,
            screenshotImageModification: this.config.screenshotImageModification,
            renderPageId: this.config.renderPageId,
            errorReporter: this.config.errorReporter
        } as IDocumentHistoryGridConfig;
    }

    /* #endregion */

    connectedCallback() {
        if (!this.isInitialized) {
            this.isInitialized = true;
            this.initialize();
        }
    }
}

customElements.define("document-history", DocumentHistory);